  <template>
    <v-navigation-drawer
    v-model="show"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    right
    >
        <v-list
        subheader
        flat
        v-if="employeef != true"
        >
        <v-subheader>Search by County/Date</v-subheader>
            <v-list-item>
                <v-list-item-content class="pa-0">
                    <v-autocomplete
                        v-model="county"
                        :items="counties"
                        item-text="title"
                        item-value="id"
                        label="County"
                    ></v-autocomplete>
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        v-if="countyf != true && employeef != true"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            label="Date Range"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" no-title scrollable range>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="rangeCancel">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>              
                    <v-btn
                        depressed 
                        tile
                        color="primary"
                        class="mx-0 mb-0 mt-2"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        v-if="countyf != true"
        >
        <v-subheader>By Employee</v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-radio-group v-model="user" class="mt-0">
                        <v-radio
                            color="primary"
                            value="all"
                            label="All"
                            class="px-2" 
                        ></v-radio>
                        <v-radio
                            v-for="(user, index) in users" 
                            :key="`user-${index}`"
                            color="primary"
                            :value="user.id"     
                            :label="user.name"        
                            class="px-2"                
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="countyf != true && employeef != true"
        >
        <v-subheader>Filter by Status</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in filteredStatuses" :key="`status-${index}`">
                        <v-checkbox
                            v-model="status"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                            hide-details
                            class="px-2"
                        ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="countyf != true && employeef != true"
        >
        <v-subheader>Filter by Payment Status</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in paymentStatus" :key="`pstatus-${index}`">
                        <v-checkbox
                            v-model="payment_status"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                            hide-details
                            class="px-2"
                        ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="countyf != true && employeef != true"
        >
        <v-subheader>Filter by Type</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in filteredTypes" :key="`type-${index}`">
                        <v-checkbox
                            v-model="type"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                            hide-details
                            class="px-2"
                        ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="countyf != true && employeef != true"
        >
        <v-subheader>Filter by Priority</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in priorities" :key="`priority-${index}`">
                        <v-checkbox
                            v-model="priority"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                            hide-details
                            class="px-2"
                        ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey', 'countyf', 'employeef'],
  data: () => ({
    status: [],
    payment_status: [],
    priority: [],
    user: "all",
    dates: [],
    type: [],
    county: "",
    menu: false,
  }),
  computed: {
        ...mapGetters({
            statuses: 'data/jobStatusArray',
            priorities: 'data/priorities',
            users: 'data/wousers',
            counties: 'data/counties',
            types: 'data/wo_types',
            paymentStatus: 'data/payment_status'
        }),
        dateRangeText () {
            if(this.dates.length == 2) {
                if(this.dates[0] > this.dates[1]) {
                    return this.dates[1] + '/' + this.dates[0]
                } else {
                    return this.dates[0] + '/' + this.dates[1] 
                }
            } else {
                return this.dates[0]
            }
        },
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value != 'all'
            })
        },
        filteredTypes() {
            return this.types.filter(type => {
                return type.value != 'all'
            })
        },
        filteredEmployees() {
            return this.users.filter(user => {
                return user.id == 18 || user.id == 8 || user.id == 34 || user.id == 6 || user.id == 2 || user.id == 33
            })
        },
  },
  created() {
      this.status = this.filter.status
      this.type = this.filter.type
      this.priority = this.filter.priority
      this.user = this.filter.user
      this.county = this.filter.county
      this.payment_status = this.filter.payment_status
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    priority(newVal) { // watch it
        this.$emit('update-priority', newVal)
    },
    status(newVal) { // watch it
        this.$emit('update-status', newVal)
    },
    payment_status(newVal) { // watch it
        this.$emit('update-paymentstatus', newVal)
    },
    type(newVal) { // watch it
        this.$emit('update-type', newVal)
    },
    user(newVal) { // watch it
        this.$emit('update-user', newVal)
    },
    county(newVal) { // watch it
        this.$emit('update-county', newVal)
    },
    dateRangeText(newVal) {
        this.$emit('update-daterange', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>